export function sessionStorageEnabled(): boolean {
    const key = 'bek-dynamic-form-enabled';
    try {
        if (window.sessionStorage) {
            window.sessionStorage.setItem(key, 'true');
            const got = window.sessionStorage.getItem(key);
            window.sessionStorage.removeItem(key);
            if (got === 'true') {
                return true;
            }
        }
        return false;
    } catch (err) {
        return false;
    }
}
